import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const useSelectedShipmentData = () => {
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds) || emptyArray;
  const selectedFulfillmentPlanIds =
    useSelector((state) =>
      Global.selectEntitiesFPIdsByFulfillmentIds(state, {
        fulfillmentIds: selectedFulfillmentIds,
      }),
    ) || emptyArray;
  const selectedSalesOrderIds =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
      }),
    ) || emptyArray;

  return {
    selectedFulfillmentIds,
    selectedFulfillmentPlanIds,
    selectedSalesOrderIds,
  };
};
